import { useEffect, useState } from "react";
import Grid from "./Grid";
import Navbar from "./Navbar";
import Score from "./Score";
import { ScoreProvider } from "./context/ScoreContext";
import { ToastProvider } from "./context/ToastContext";

const Home = () => {
    // console.log("home twice?");
    function calculateDateDifference(date1, date2) {
        // Parse the dates as day-month-year
        var parts1 = date1.split("/");
        var parts2 = date2.split("/");
        var d1 = new Date(parts1[2], parts1[1] - 1, parts1[0]);
        var d2 = new Date(parts2[2], parts2[1] - 1, parts2[0]);

        // Calculate the difference in milliseconds
        var diff = Math.abs(d1.getTime() - d2.getTime());

        // Convert to days and return
        return Math.ceil(diff / (1000 * 60 * 60 * 24));
    }
    const [day, setDay] = useState(-1);
    useEffect(() => {
        const initialDay = "24/02/2024";
        const today = new Date().toLocaleDateString("en-GB", { timeZone: 'America/Vancouver' });

        let diff = calculateDateDifference(initialDay, today) + 0;
        // let diff = 120;
        const savedDay = localStorage.getItem(`day${diff}`);
        // console.log(diff);
        // const savedDay = 21;
        if (!savedDay) {
            localStorage.setItem(`day${diff}`, JSON.stringify({ "cs": 3, "score": [0, 0, 0, 0, 0, 0, 0, 0, 0, 0], "ended": false }));
        }
        setDay(diff);
    }, []);


    return (
        <div style={{ position: "relative", minHeight: "100vh" }}>
            {day < 0 ? <p>Loading...</p> :
                <ScoreProvider day={day}>
                    <div className="home">
                        <div>
                            <Navbar />
                            <Grid day={day} />
                        </div>
                        <ToastProvider>
                            <Score />
                        </ToastProvider>
                    </div>
                </ScoreProvider>}
        </div>
    );
}

export default Home;
